import React from 'react';

import ContextContentMixin from './../context_content_mixin';
import CustomStylesMixin from './../custom_styles_mixin';
import RevealMixin from '../reveal_mixin';
import Color from 'color';

import createReactClass from 'create-react-class';
export default createReactClass({
  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass: function() {
    var className = 'buttons-container';
    if (this.props.has_status_page == 'no') {
      className += ' single-button';
    }
    return className;
  },

  render: function() {
    return (
      <div>
        <div className="sign-container">
          <div
            className="nob"
            style={this.mergeStyles(
              this.borderColor(this.props.sign_frame_color),
              this.background_color(this.props.background_color),
            )}
          ></div>
          <div
            className="post left"
            style={this.background_color(this.props.sign_frame_color)}
          ></div>
          <div
            className="post right"
            style={this.background_color(this.props.sign_frame_color)}
          ></div>
          <div
            className="pane"
            style={this.mergeStyles(
              this.borderColor(this.props.sign_frame_color),
              this.background_color(this.props.sign_background_color),
            )}
          >
            <div
              className="headline"
              style={this.color(this.props.sign_text_color)}
            >
              503
            </div>
            <div
              className="context"
              style={this.color(this.props.sign_text_color)}
            >
              Looks like we're having
              <br />
              some server issues.
            </div>
          </div>
        </div>
        <div className="text-container">
          <div className="headline" style={this.secondary_text_color()}>
            503
          </div>
          <div className="context" style={this.primary_text_color()}>
            {this.contextContent()}
          </div>
          <div className={this.buttonsClass()}>
            <a
              href={this.href(this.props.status_page_url)}
              style={this.mergeStyles(
                this.borderButton(),
                this.has_status_page(),
              )}
              target="_blank"
            >
              <span className="fa fa-power-off"></span>
              View Statuspage
            </a>
            <a
              href={this.support_email_address()}
              style={this.borderButton()}
              target="_blank"
            >
              <span className="fa fa-warning"></span>
              Report a problem
            </a>
          </div>
        </div>
      </div>
    );
  },
});
